module.exports = __webpack_public_path__ + "img/basic_wash-mask_halfset_202306.8a47e19f.jpg";